import React, { useEffect, useRef, useState } from 'react';

import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

import PrimeReact from 'primereact/api';

import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Tooltip } from 'primereact/tooltip';

import { useHistory } from 'react-router-dom';
import { useToast } from '../../../hooks/toast';
import { Container } from './styles';
import api from '../../../services/api';

 interface IReferenceProperties {
  horas_referencia_id: number | null;
  horas_referencia_nome: string;
}

const Reference: React.FC = () => {
  // active ripple effect
  PrimeReact.ripple = true;

  const emptyReference = {
    horas_referencia_id: null,
    horas_referencia_nome: '',
  };

  const [references, setReferences] = useState<IReferenceProperties[]>([]);
  const [reference, setReference] = useState(emptyReference);
  const [deleteReference, setDeleteReferenceDialog] = useState(false);
  const [deleteReferencesDialog, setDeleteReferencesDialog] = useState(false);
  const [selectedReferences, setSelectedReferences] = useState<IReferenceProperties[]>([]);

  // para tabela
  const [globalFilter, setGlobalFilter] = useState('');
  const dt = useRef(null);
  const { addToast } = useToast();
  const history = useHistory();

  useEffect(() => {
    (async () => {
      const response = await api.get('/lawsuits/references/show/all');
      setReferences(response.data);
    })();
  }, []);

  const columns = [
    { field: 'horas_referencia_id', header: 'Código', sortable: true },
    { field: 'horas_referencia_nome', header: 'Descrição', sortable: true },
  ];

  const dynamicColumns = columns.map((col) => (
    <Column
      key={col.field}
      field={col.field}
      header={col.header}
      sortable
    />
  ));

  const handleCreate = () => {
    history.push('/lawsuit/reference/create');
  };

  const hidedeleteReference = () => {
    setDeleteReferenceDialog(false);
  };

  const hidedeleteReferencesDialog = () => {
    setDeleteReferencesDialog(false);
  };

  // eslint-disable-next-line no-shadow
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const editReference = (rowData:any) => {
    history.push(`/lawsuit/reference/edit/${rowData.horas_referencia_id}`);
  };

  // eslint-disable-next-line @typescript-eslint/no-shadow
  const confirmDeleteReference = (reference: React.SetStateAction<{
    horas_referencia_id: null; horas_referencia_nome: string;
  }>) => {
    setReference(reference);
    setDeleteReferenceDialog(true);
  };

  const deleteGroup = () => {
    api.delete(`/lawsuits/references/delete/${reference.horas_referencia_id}`);

    setDeleteReferenceDialog(false);

    const updatedRecords = references
      .filter((val) => val.horas_referencia_id !== reference.horas_referencia_id);
    setReferences(updatedRecords);

    addToast({
      type: 'success',
      title: 'Cadastro excluído!',
      description:
        'O cadastro selecionado foi excluído com sucesso!',
    });
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const actionBodyTemplate = (rowData: any) => (
    <>
      <Button
        type="button"
        icon="pi pi-pencil"
        tooltip="Alterar cadastro"
        tooltipOptions={{ position: 'left' }}
        className="p-button-rounded p-button-text p-button-plain p-mr-2"
        onClick={() => { editReference(rowData); }}
      />
      <Button
        type="button"
        icon="pi pi-trash"
        tooltip="Excluir cadastro"
        tooltipOptions={{ className: 'red-tooltip', position: 'left' }}
        className="p-button-rounded p-button-text p-button-plain"
        onClick={() => { confirmDeleteReference(rowData); }}
      />
    </>
  );

  const header = (
    <div className="flex align-items-center export-buttons">
      <Button
        type="button"
        label="Novo"
        icon="pi pi-plus"
        className="p-button-primary p-mr-2"
        onClick={handleCreate}
        tooltip="Novo cadastro"
        tooltipOptions={{ position: 'right' }}
      />
      <span className="p-input-icon-left p-ml-auto">
        <i className="pi pi-search" />
        <InputText type="search" value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Pesquisar na tabela" />
      </span>
    </div>
  );

  const paginatorLeft = <Button type="button" icon="pi pi-refresh" className="p-button-text" />;
  const paginatorRight = <Button type="button" icon="pi pi-cloud" className="p-button-text" />;

  const deleteReferenceFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteReference} />
      <Button type="button" label="Sim" icon="pi pi-check" className="p-button-text" onClick={deleteGroup} />
    </>
  );
  const deleteReferencesDialogFooter = (
    <>
      <Button type="button" label="Não" icon="pi pi-times" className="p-button-text" onClick={hidedeleteReferencesDialog} />
      {/* <Button label="Sim" icon="pi pi-check" className="p-button-text"
      onClick={deleteselectedReferences} /> */}
    </>
  );

  return (
    <Container>
      <header>
        <div>
          <h1>Referência de Horas</h1>
        </div>
      </header>

      <div className="datatable-responsive">

        <div className="card">

          <Tooltip target=".export-buttons>button" position="bottom" />

          <DataTable
            tableClassName="table-references table"
            id="table-references"
            ref={dt}
            value={references}
            editMode="row"
            dataKey="horas_referencia_id"
            header={header}
            stripedRows
            className="p-datatable-sm"
            paginator
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords}"
            rows={50}
            rowsPerPageOptions={[10, 20, 50]}
            paginatorLeft={paginatorLeft}
            paginatorRight={paginatorRight}
            globalFilter={globalFilter}
            emptyMessage="Nenhum registro encontrado."
            selectionMode="multiple"
            selection={selectedReferences}
            onSelectionChange={(e) => {
              const selReferences = e.value as IReferenceProperties[];
              setSelectedReferences(selReferences);
            }}
            onRowDoubleClick={(e) => editReference(e.data)}
          >
            {/* <Column selectionMode="multiple" headerStyle={{ width: '3rem' }} /> */}
            {dynamicColumns}
            <Column body={actionBodyTemplate} align="right" style={{ width: '120px' }} />
          </DataTable>

        </div>

        <div>
          <Dialog visible={deleteReference} style={{ width: '450px' }} header="Confirmação" modal footer={deleteReferenceFooter} onHide={hidedeleteReference}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {reference && (
              <span>
                Você tem certeza que deseja excluir
                <br />
                <br />
                <b>{reference.horas_referencia_nome}</b>
                ?
              </span>
              )}
            </div>
          </Dialog>

          <Dialog visible={deleteReferencesDialog} style={{ width: '450px' }} header="Confirmação" modal footer={deleteReferencesDialogFooter} onHide={hidedeleteReferencesDialog}>
            <div className="confirmation-content">
              <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
              {reference
              && <span>Você tem certeza que deseja excluir os cadastros selecionados?</span>}
            </div>
          </Dialog>
        </div>

      </div>

    </Container>

  );
};

export default Reference;
